import { Rarity } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSeriesNav } from 'hooks/commonGame/useSeriesNav';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { useLifecycle } from 'hooks/useLifecycle';

export const useFilteredShardsChests = () => {
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const {
    flags: { enableSeriesOnboardingPacks = false },
  } = useFeatureFlags();
  const seriesNav = useSeriesNav();

  const { cardShardsChests } = currentUser || {};

  return cardShardsChests?.filter(shard => {
    if (lifecycle?.hideCommonFeatures) {
      return shard.rarity !== Rarity.common;
    }
    if (seriesNav) {
      return shard.cardSet?.slug === 'winter';
    }
    if (!enableSeriesOnboardingPacks) {
      return (
        shard.rarity !== Rarity.common ||
        shard.cardSet?.slug === 'common-base-set'
      );
    }
    return true;
  });
};
